/* eslint-disable react-hooks/exhaustive-deps */

import React,{useEffect, useState} from 'react';
import Cookies from 'js-cookie';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { AreaTitle } from './appBar';
import { StatusIcons } from './helpers';
import {AgeCheck} from "./ageCheck";
import { GateCount } from './gateScan';
import { ResCheck } from './resCheck';
import { Admin } from './admin';
import { RataCheck } from './rataCheck';
import { ManageRes } from './manageRes';
import { ManageSpeakerRes } from './manageSpeakerRes';

export const Authorized=()=>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const action =  urlParams.get("act");
    const pid = urlParams.get("pid");

    const authKey = Cookies.get("nsj_access");
    const [area,setArea]=useState({
            AreaID: "",
            AreaName: "",
            ScanTime: undefined,
            Status: "",
            ContactName: "",
            ContactPhone: "",
            LastWait:0,
            CheckIn:0,
            AgeCheck:0,
            ResCheck:0
        }
    );

    const [showScanConfirm,setShowScanConfirm]=useState(false);
    const [showScanMismatch,setShowScanMismatch]=useState(false);
    const [showStatusConfirm,setShowStatusConfirm]=useState(false);
    const [showClosed,setShowClosed]=useState(false);

    const [newStatus, setNewStatus]=useState("");
    const [showAgeCheck,setShowAgeCheck]=useState(false);
    const [showGateScan,setShowGateScan]=useState(false);
    const [showResCheck,setShowResCheck]=useState(false);
    const [showManageRes,setShowManageRes]=useState(false);
    const [showManageSpeakerRes,setShowManageSpeakerRes]=useState(false);

    const [showRataCheck,setShowRataCheck]=useState(false);

    const showConfirm=()=>{
        setShowScanConfirm(true);
    }

    const hideConfirm=()=>{
        setShowScanConfirm(false);
    }

    const showConfirmStatus=()=>{
        setShowStatusConfirm(true);
    }

    const openClosedWarning=()=>{
        setShowClosed(true);
    }

    const closeClosedWarning=()=>{
        setShowClosed(false);
    }

    const hideConfirmStatus=()=>{
        setShowStatusConfirm(false);
    }

    const openAgeCheck=()=>{
        setShowAgeCheck(true);
    }

    const closeAgeCheck=()=>{
        setShowAgeCheck(false);
    }

    const openRataCheck=()=>{
        setShowRataCheck(true);
    }

    const closeRataCheck=()=>{
        setShowRataCheck(false);
    }

    const openGateScan=()=>{
        setShowGateScan(true);
    }

    const closeGateScan=()=>{
        setShowGateScan(false);
    }

    const closeScanMismatch=()=>{
        setShowScanMismatch(false);
    }

     const openResCheck=()=>{
        setShowResCheck(true);
    }

    const closeResCheck=()=>{
        setShowResCheck(false);
    }

    const openManageRes=()=>{
        setShowManageRes(true);
    }

    const openManageSpeakerRes=()=>{
        setShowManageSpeakerRes(true);
    }
    
    const closeManageRes=()=>{
        setShowManageRes(false);
    }

    const scanTag=()=>{
        console.log("Scan");
        const url = "api/index.php/program/scanTag";
        const postData = new FormData();
        if (area.AreaID!==""){
            postData.append("id",area.AreaID);
            fetch (url,{
                method:"POST",
                body:postData
            }).then(response=>response.json()).then(data=>{
                console.log(data);
                hideConfirm();
            })
        }
    }

    const changeStatus=(event)=>{
        console.log(event.value);
        setNewStatus(event.value.value);
    }

    const clearWaitTime=()=>{
        console.log("Set New Status");
        const url = "api/index.php/program/clearWaitTime";
        const postData = new FormData();
        if (area.AreaID!==""){
            postData.append("id",area.AreaID);
            fetch (url,{
                method:"POST",
                body:postData
            }).then(response=>response.json()).then(data=>{
                console.log(data);
            })
        }
    }


    const setStatus=()=>{
        console.log("Set New Status");
        const url = "api/index.php/program/setStatus";
        const postData = new FormData();
        if (area.AreaID!==""){
            postData.append("id",area.AreaID);
            postData.append("status", newStatus);
            fetch (url,{
                method:"POST",
                body:postData
            }).then(response=>response.json()).then(data=>{
                console.log(data);
                getPAFromKey();
                hideConfirmStatus();
            })
        }
    }

    const getPAFromKey = async ()=>{
        const url= "api/index.php/auth/getPaFromKey?key="+authKey;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            setArea(data[0]);
        })
    }

    const ConfirmScan=()=>{
        return(
            <Dialog title="TAG SCANNED" closeIcon={false}>
                <p>Do you want to update the wait time for {area.AreaName}?</p>
                <DialogActionsBar>
                    <Button size="large" themeColor='primary' onClick={scanTag}>YES</Button>
                    <Button size="large" onClick={hideConfirm}>No</Button>
                </DialogActionsBar>
            </Dialog>
        )
    }

    const ConfirmStatus=()=>{
        return(
            <Dialog title="Set Area Status" closeIcon={false}>
                <p>Are you sure you want to change the status for {area.AreaName} to {newStatus}?</p>
                <DialogActionsBar>
                    <Button size="large" themeColor='primary' onClick={setStatus}>YES</Button>
                    <Button size="large" onClick={hideConfirmStatus}>No</Button>
                </DialogActionsBar>
            </Dialog>
        )
    }

    const ScanMismatch=()=>{
        return(
            <Dialog className='warning' width={"90vw"}>
                <p><strong>The card scanned ({pid}) does not match your program area. No update recorded.</strong></p> 
                <DialogActionsBar>
                    <Button size='large' fillMode="outline" onClick={closeScanMismatch}>CLOSE</Button>
                </DialogActionsBar>
            </Dialog>
        )
    }

    const ClosedWarning=()=>{
        return(
            <Dialog className='warning' width={"90vw"}>
                <p><strong>The selected program area is not open. Set the program area's status to open to start recording wait times.</strong></p> 
                <DialogActionsBar>
                    <Button size='large' fillMode="outline" onClick={closeClosedWarning}>CLOSE</Button>
                </DialogActionsBar>
            </Dialog>
        )
    }

    useEffect(()=>{
        console.log(area);
        if (area.AreaID!==""){
            if (action==="scan"){
                console.log(pid);
                console.log(area);
                if (pid===area.AreaID){
                    if (area.Status==="OPEN"){
                        //don't upate the wait time if the area is closed.
                        showConfirm();
                    }else{
                        setShowClosed(true);
                    }
                }else{
                    console.log("Mismatch:" + pid + " / " + area.AreaID);
                    setShowScanMismatch(true);
                }
            }
        }
    },[area])

    useEffect(()=>{
        if (newStatus!==""){
            showConfirmStatus();
        }
    },[newStatus])

    useEffect(()=>{
        if (authKey){
            getPAFromKey();
        }   
    },[])
    
    return(
        <>
        {area.AreaID!==""?
            //Area ID is set
            <>
            {area && area.AreaID!=="NJ26-ADMIN"?
                //Not admin access
                <>
                {showScanMismatch?<ScanMismatch></ScanMismatch>:null}
                {showScanConfirm?<ConfirmScan></ConfirmScan>:null}
                {showStatusConfirm?<ConfirmStatus></ConfirmStatus>:null}
                {showClosed?<ClosedWarning></ClosedWarning>:null}
                {showAgeCheck?<AgeCheck onClose={closeAgeCheck} areaId={area.AreaID} rataCheck={area.RataCheck}></AgeCheck>:null}
                {showGateScan?<GateCount onClose={closeGateScan} areaId={area.AreaID}></GateCount>:null}
                {showResCheck?<ResCheck onClose={closeResCheck} areaId={area.AreaID} checkIn={area.CheckIn}></ResCheck>:null}
                {showRataCheck?<RataCheck onClose={closeRataCheck} areaId={area.AreaID} rataCheck={area.RataCheck}></RataCheck>:null}
                {showManageSpeakerRes?<ManageSpeakerRes onClose={closeManageRes} areaId={area.AreaID} checkIn={area.CheckIn} areaName={area.AreaName}></ManageSpeakerRes>:null}
                {showManageRes?<ManageRes onClose={closeManageRes} areaId={area.AreaID} checkIn={area.CheckIn} areaName={area.AreaName}></ManageRes>:null}
                <div className="App">
                    <AreaTitle area={area.AreaName}></AreaTitle>
                    <div style={{padding:"10px"}}>
                        <DropDownList
                            data={[
                                {title:"Program Area Open",value: "OPEN"},
                                {title:"Temporary Hold",value: "HOLD"},
                                {title:"At Capacity",value: "CAPACITY"},
                                {title:"Program Area Closed",value: "CLOSED"}
                            ]}
                            defaultItem={{title:"Change Area Status", value:""}}
                            textField='title' 
                            dataItemKey='value'
                            onChange={changeStatus}
                            value={{title:"Change Area Status", value:""}}
                            fillMode='outline'
                            size='large'
                        />
                        <h3>Current Status: </h3>
                        <h3>{StatusIcons({status:area.Status,size:"small"})} <span style={{fontSize:"xx-large"}}>{area.Status}</span></h3>
                    </div>
                    
                    <div style={{marginLeft:"10px", marginRight:"10px"}}>
                        <p style={{fontSize:"larger"}}>Tap or scan a card for this program area<br/>to 
                            update the area wait time</p>
                    </div>
                    <div >
                        <Button fillMode={"solid"} themeColor={"primary"} size={"large"} style={{width:"95vw", marginBottom:"10px"}}onClick={clearWaitTime}>RESET WAIT TIME</Button>                   
                    </div>
                    {area.CheckIn===1?
                        //enable gate scan
                        <div >
                            <Button fillMode={"solid"} themeColor={"primary"} size={"large"} style={{width:"95vw"}}onClick={openGateScan}>CHECK IN</Button>                   
                        </div>
                    :null
                    }
                    {area.AgeCheck===1?
                        //enable age check features
                        <div style={{marginTop:"20px"}}>
                            <Button fillMode={"solid"} themeColor={"primary"} size={"large"} style={{width:"95vw"}}onClick={openAgeCheck}>VERIFY AGE</Button>                   
                        </div>
                    :null
                    }
                    {area.RataCheck===1?
                        //enable age check features
                        <div style={{marginTop:"20px"}}>
                            <Button fillMode={"solid"} themeColor={"primary"} size={"large"} style={{width:"95vw"}}onClick={openRataCheck}>RATA VERIFICATION</Button>                   
                        </div>
                    :null
                    }
                    {area.ResCheck===1?
                    //enable reservation features
                    area.AreaID==="NJ26-FC"?
                        <>
                            <div style={{marginTop:"20px"}}>
                                <Button fillMode={"solid"} themeColor={"primary"} size={"large"} style={{width:"95vw"}}onClick={openResCheck}>CHECK RESERVATION</Button>                   
                            </div>
                            <div style={{marginTop:"20px"}}>
                                <Button fillMode={"solid"} themeColor={"primary"} size={"large"} style={{width:"95vw"}}onClick={openManageSpeakerRes}>MANAGE RESERVATIONS</Button>                   
                            </div>
                        </>
                    :
                    <>
                        <div style={{marginTop:"20px"}}>
                            <Button fillMode={"solid"} themeColor={"primary"} size={"large"} style={{width:"95vw"}}onClick={openResCheck}>CHECK RESERVATION</Button>                   
                        </div>
                        <div style={{marginTop:"20px"}}>
                            <Button fillMode={"solid"} themeColor={"primary"} size={"large"} style={{width:"95vw"}}onClick={openManageRes}>MANAGE RESERVATIONS</Button>                   
                        </div>
                    </>
                    :null
                    }
                    
                </div>
            </>
            :
                //Admin access
                <Admin></Admin>
            }
            </>
        :
            //Area ID not set
            <></>
        }
        </>
    )
}